import { FC } from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

interface ContactSupportCardProps {
  onContactClick: () => void
}

export const ContactSupportCard: FC<ContactSupportCardProps> = ({ onContactClick }) => {
  const { t } = useTranslation()

  return (
    <StyledCard>
      <CardImage src="/assets/images/contact&support.svg" alt="" />
      <CardContent>
        <TextContent>
          <Title>{t('helpCenter.contactSupport.title')}</Title>
          <Subtitle>{t('helpCenter.contactSupport.subtitle')}</Subtitle>
        </TextContent>
        <ContactButton onClick={onContactClick}>{t('support.contact')}</ContactButton>
      </CardContent>
    </StyledCard>
  )
}

const StyledCard = styled.div`
  position: relative;
  border-radius: 16px;
  background:
    radial-gradient(102.75% 2084.17% at 1.01% 0%, rgba(var(--violet-600-rgb), 0.4) 0%, rgba(var(--violet-900-rgb), 0.2) 100%),
    var(--bg-quaternary);
  overflow: hidden;
`

const CardImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const CardContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  padding-left: 76px;

  @media (min-width: 600px) {
    padding-left: 100px;
  }
`

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`

const Title = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: var(--text-primary);
`

const Subtitle = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: var(--text-quaternary, #A1A1AA);
`

const ContactButton = styled.button`
  background: var(--button-primary-color, var(--violet-600));
  color: white;
  border: none;
  border-radius: 12px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`

export default ContactSupportCard
